import React, { createContext, useContext, useState } from "react";
import { api } from "../../../services/api";

/* ======================================
   TYPES
====================================== */

interface ICompra {
  id: string;
  [key: string]: any;
}

interface ComprasContextData {
  compras: ICompra[];
  carregarCompras: () => Promise<void>;
  addCompra: (compra: any) => Promise<void>;
  updateCompra: (compra: ICompra) => void;
  removeCompra: (id: string) => void;
}

/* ======================================
   CONTEXT
====================================== */

const ComprasContext = createContext<ComprasContextData>(
  {} as ComprasContextData,
);

/* ======================================
   PROVIDER
====================================== */

export const ComprasProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [compras, setCompras] = useState<ICompra[]>([]);

  /* ======================================
     CARREGAR COMPRAS
  ====================================== */

  async function carregarCompras() {
    try {
      if (!localStorage.getItem("apiAccessToken")) {
        setCompras([]);
        return;
      }
      // v2: cada item traz a combinação comprada (variationText).
      const response = await api.get(`/v2/orders`);
      setCompras(response.data || []);
    } catch (error: any) {
      console.error(error);
    }
  }

  /* ======================================
     ADICIONAR COMPRA
  ====================================== */

  async function addCompra(compra: any) {
    try {
      const response = await api.post(`/orders`, compra);
      setCompras((prev) => [...prev, response.data]);
    } catch (error: any) {
      console.error(error);
      throw new Error(error?.message || "Erro ao adicionar compra");
    }
  }

  /* ======================================
     ATUALIZAR LOCAL
  ====================================== */

  function updateCompra(compra: ICompra) {
    setCompras((prev) => prev.map((c) => (c.id === compra.id ? compra : c)));
  }

  /* ======================================
     REMOVER LOCAL
  ====================================== */

  function removeCompra(id: string) {
    setCompras((prev) => prev.filter((c) => c.id !== id));
  }

  /* ======================================
     RETURN
  ====================================== */

  return (
    <ComprasContext.Provider
      value={{
        compras,

        carregarCompras,

        addCompra,

        updateCompra,

        removeCompra,
      }}
    >
      {children}
    </ComprasContext.Provider>
  );
};

/* ======================================
   HOOK
====================================== */

export const useCompras = () => useContext(ComprasContext);
